import { DataFilterModel } from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';

class EnumHelper {
  public dataOriginIsBilling(data: DataFilterModel) {
    return (
      refs.enums.DataOrigin[data.DataOrigin] ==
        refs.enums.DataOrigin.Billing.toString() ||
      refs.enums.DataOrigin[data.DataOrigin] ==
        refs.enums.DataOrigin[refs.enums.DataOrigin.Billing]
    );
  }

  public dataOriginIsInsurance(data: DataFilterModel) {
    return (
      refs.enums.DataOrigin[data.DataOrigin] ==
        refs.enums.DataOrigin.Insurance.toString() ||
      refs.enums.DataOrigin[data.DataOrigin] ==
        refs.enums.DataOrigin[refs.enums.DataOrigin.Insurance]
    );
  }

  public dataPaymentMethodIsCoBillingTIM(data: DataFilterModel) {
    return (
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.PaymentMethod.CoBillingTIM.toString() ||
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.DataOrigin[refs.enums.PaymentMethod.CoBillingTIM]
    );
  }

  public dataPaymentMethodIsCredit(data: DataFilterModel) {
    return (
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.PaymentMethod.Credit.toString() ||
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.DataOrigin[refs.enums.PaymentMethod.Credit]
    );
  }

  public dataPaymentMethodIsDebit(data: DataFilterModel) {
    return (
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.PaymentMethod.Debit.toString() ||
      refs.enums.PaymentMethod[data.PaymentMethod] ==
        refs.enums.DataOrigin[refs.enums.PaymentMethod.Debit]
    );
  }
}

export const enumHelper = new EnumHelper();
